/* Stormgull: raised wings, downstroke, cupped recovery. Fixed head and feet
 * keep the body readable while the flight feathers carry the motion. */

export const stormgull_0 = [
  '................',
  '................',
  '................',
  'o..............o',
  'Mo............oM',
  'wMo..........oMw',
  '.wMo..oMMo..oMw.',
  '..wMooMwwMooMw..',
  '...wMoweewoMw...',
  '....wMoyyoMw....',
  '.....woMMow.....',
  '.......oo.......',
  '.......yy.......',
  '................',
  '................',
  '................',
];

export const stormgull_1 = [
  '................',
  '................',
  '................',
  '................',
  'o..............o',
  'Mo............oM',
  'wMo...oMMo...oMw',
  '.wMo.oMwwMo.oMw.',
  '..wMooweewooMw..',
  '...wMMoyyoMMw...',
  '....wwoMMoww....',
  '.......oo.......',
  '.......yy.......',
  '................',
  '................',
  '................',
];

export const stormgull_2 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  'oo....oMMo....oo',
  'MMo..oMwwMo..oMM',
  'wwMoooweewoooMww',
  '..wMMMoyyoMMMw..',
  '...wwwoMMowww...',
  '.......oo.......',
  '.......yy.......',
  '................',
  '................',
  '................',
];

export const stormgull_3 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oMMo......',
  '.....oMwwMo.....',
  'ooooooweewoooooo',
  'MMMMMMoyyoMMMMMM',
  'wwwwwwoMMowwwwww',
  '.......oo.......',
  '.......yy.......',
  '................',
  '................',
  '................',
];

export const stormgull_4 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oMMo......',
  '.....oMwwMo.....',
  '....ooweewoo....',
  '..ooMMoyyoMMoo..',
  'ooMMwwoMMowwMMoo',
  'MMww...oo...wwMM',
  'ww.....yy.....ww',
  '................',
  '................',
  '................',
];

export const stormgull_5 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oMMo......',
  '.....oMwwMo.....',
  '.....oweewo.....',
  '...ooMoyyoMoo...',
  '.ooMMwoMMowMMoo.',
  'oMMww..oo..wwMMo',
  'Mww....yy....wwM',
  'w..............w',
  '................',
  '................',
];

export const stormgull_6 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '......oMMo......',
  '.....oMwwMo.....',
  'oo...oweewo...oo',
  'MMoooMoyyoMoooMM',
  'wwMMMwoMMowMMMww',
  '..www..oo..www..',
  '.......yy.......',
  '................',
  '................',
  '................',
];

export const stormgull_7 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  'o..............o',
  'Mo....oMMo....oM',
  'wMo..oMwwMo..oMw',
  '.wMo.oweewo.oMw.',
  '..wMoMoyyoMoMw..',
  '...wMwoMMowMw...',
  '....w..oo..w....',
  '.......yy.......',
  '................',
  '................',
  '................',
];
